// extracted by mini-css-extract-plugin
module.exports = {"container":"_3hY_a","cover":"_1J-T0","dark_mode":"_36qoC","light_mode":"_2taKs","open":"sKuo7"};